import { render, staticRenderFns } from "./simpleDetails.vue?vue&type=template&id=4bc02fd8&scoped=true&"
import script from "./simpleDetails.vue?vue&type=script&lang=js&"
export * from "./simpleDetails.vue?vue&type=script&lang=js&"
import style0 from "./simpleDetails.vue?vue&type=style&index=0&id=4bc02fd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc02fd8",
  null
  
)

export default component.exports